import axiosInstance from './axiosInstance';
import { decodeJwtToken } from '../utils/jwtUtils';

export const userApi = {

  registerUser: async (userData) => {
    try {
      // Get the JWT token from localStorage or wherever it's stored
      const rawToken = localStorage.getItem('authToken') || sessionStorage.getItem('authToken') || localStorage.getItem('token') || sessionStorage.getItem('token');
      const token = rawToken ? rawToken.trim().replace(/^"|"$/g, '').replace(/^Bearer\s+/i, '') : null;
      
      if (!token) {
        throw new Error('No authentication token found');
      }
      
      // Decode the JWT token to extract user ID
      const decodedToken = decodeJwtToken(token);
      if (!decodedToken || !decodedToken.id) {
        throw new Error('Invalid token or missing admin ID');
      }
      
      // Add the createdBy field with the current user's ID
      // Map 'role' field to 'roleName' for backend compatibility
      // Standard Role enum values that the backend recognizes
      const standardRoles = ['SUPER_ADMIN', 'ADMIN', 'USER', 'GATEMEN', 'REGISTERED_USER', 'RECRUITER', 'SR_RECRUITER', 'HR_HEAD', 'HIRING_MANAGER'];
      const roleValue = userData.role ? userData.role.toUpperCase().replace(/\s+/g, '_') : '';
      const isStandardRole = standardRoles.includes(roleValue);

      const userDataWithCreatedBy = {
        ...userData,
        role: isStandardRole ? roleValue : null, // Only send role if it's a standard enum value
        roleName: userData.role, // Pass role name as roleName for custom role lookup
        createdBy: decodedToken.id
      };

      const response = await axiosInstance.post('/Corrohealth/users/register', userDataWithCreatedBy);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  bulkRegisterUsers: async (usersArray) => {
    try {
      // Validate input is an array
      const payload = Array.isArray(usersArray) ? usersArray : [];
      const response = await axiosInstance.post('/Corrohealth/users/bulk-register', payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  assignVehicleAndStation: async (ids, assignedVehicle, assignedStation) => {
    try {

      const payload = {
        ids: Array.isArray(ids) ? ids : [ids],
        assignedVehicle: assignedVehicle,
        // Backend expects 'route' field in AssignmentRequest, map assignedStation -> route
        route: assignedStation
      };

      const response = await axiosInstance.put('/Corrohealth/admin/assign', payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getUsersByCompany: async (page = 1, size = 10, role, { department, location, sortBy, sortDirection, search } = {}) => {
    try {
      const rawToken = localStorage.getItem('authToken') || sessionStorage.getItem('authToken') || localStorage.getItem('token') || sessionStorage.getItem('token');
      const token = rawToken ? rawToken.trim().replace(/^"|"$/g, '').replace(/^Bearer\s+/i, '') : null;
      if (!token) {
        throw new Error('No authentication token found');
      }

      const decodedToken = decodeJwtToken(token);
      if (!decodedToken || !decodedToken.company) {
        throw new Error('Invalid token or missing company');
      }

      // Convert 1-based page to 0-based for Spring Boot
      const springBootPage = page - 1;

      const params = {
        company: decodedToken.company,
        page: springBootPage,
        size: size
      };
      if (role) {
        params.role = role;
      }
      if (department) {
        params.department = department;
      }
      if (location) {
        params.location = location;
      }
      if (sortBy) {
        params.sortBy = sortBy;
      }
      if (sortDirection) {
        params.sortDirection = sortDirection;
      }
      if (search && search.trim()) {
        params.search = search.trim();
      }

      const response = await axiosInstance.get('/Corrohealth/admin/users', { params });
      console.log(response.data,"response.data")
      return response.data;
    } catch (error) {
      throw error;
    }
  },

 

  getUserQRCode: async (userId) => {
    try {
      const rawToken = localStorage.getItem('authToken') || sessionStorage.getItem('authToken') || localStorage.getItem('token') || sessionStorage.getItem('token');
      const token = rawToken ? rawToken.trim().replace(/^"|"$/g, '').replace(/^Bearer\s+/i, '') : null;
      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axiosInstance.get(`/Corrohealth/admin/user/${userId}/qrcode`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getUserLogs: async (empId) => {
    try {
      const response = await axiosInstance.get(`/Corrohealth/admin/user/${empId}/logs`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getUsersWithQR: async () => {
    try {
      const rawToken = localStorage.getItem('authToken') || sessionStorage.getItem('authToken') || localStorage.getItem('token') || sessionStorage.getItem('token');
      const token = rawToken ? rawToken.trim().replace(/^"|"$/g, '').replace(/^Bearer\s+/i, '') : null;
      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axiosInstance.get('/Corrohealth/admin/userswithqr');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  changeStatus: async (id, status) => {
    try {
      const rawToken = localStorage.getItem('authToken') || sessionStorage.getItem('authToken') || localStorage.getItem('token') || sessionStorage.getItem('token');
      const token = rawToken ? rawToken.trim().replace(/^"|"$/g, '').replace(/^Bearer\s+/i, '') : null;
      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axiosInstance.put('/Corrohealth/admin/changeStatus', {
        id: id,
        status: status
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  generateBulkQR: async (department, location) => {
    try {
      const response = await axiosInstance.post('/Corrohealth/admin/bulkuserswithqr', {
        department: department,
        location: location
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  unlockAccount: async (userId) => {
    try {
      const response = await axiosInstance.post(`/Corrohealth/admin/unlock-account/${userId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateUser: async (userId, updates) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/admin/users/${userId}`, updates);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  bulkUpdateDepartment: async (department) => {
    try {
      const response = await axiosInstance.put('/Corrohealth/admin/users/bulk-update-department', { department });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

};

export const vehicleApi = {
  addVehicle: async (vehicleData) => {
    try {
      const response = await axiosInstance.post('/Corrohealth/vehicles/add', vehicleData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getAllVehicles: async () => {
    try {
      // Backend now handles location-based filtering based on user's role and assigned locations
      // No need to pass location parameter - Super Admin gets all, others get their assigned locations
      const response = await axiosInstance.get('/Corrohealth/vehicles/getAllVehicles');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getVehiclesByLocation: async (location) => {
    try {
      const response = await axiosInstance.get(`/Corrohealth/vehicles/by-location/${encodeURIComponent(location)}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getDropLocations: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/vehicles/drop-locations');
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getVehicleById: async (id) => {
    try {
      const response = await axiosInstance.get(`/Corrohealth/vehicles/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  updateVehicle: async (id, data) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/vehicles/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  updateVehicleStatus: async (id, status) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/vehicles/${id}/status`, status);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  deleteVehicle: async (id) => {
    try {
      const response = await axiosInstance.delete(`/Corrohealth/vehicles/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export const routesApi = {
  addRoute: async (routeData) => {
    try {
      const response = await axiosInstance.post('/Corrohealth/admin/addroute', routeData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getAllRoutes: async (filters) => {
    try {
      const rawToken = localStorage.getItem('authToken') || sessionStorage.getItem('authToken') || localStorage.getItem('token') || sessionStorage.getItem('token');
      const token = rawToken ? rawToken.trim().replace(/^"|"$/g, '').replace(/^Bearer\s+/i, '') : null;
      const decoded = token ? decodeJwtToken(token) : null;
      const tokenLocation = decoded?.location || decoded?.Location;
      const params = { };
      if (filters?.location) params.location = filters.location;
      else if (tokenLocation) params.location = tokenLocation;
      const response = await axiosInstance.get('/Corrohealth/admin/routes', { params });
      const payload = response?.data;
      // Normalize to { data: routesArray, count }
      const routesArray = Array.isArray(payload) 
        ? payload 
        : Array.isArray(payload?.data) 
          ? payload.data 
          : Array.isArray(payload?.content) 
            ? payload.content 
            : Array.isArray(payload?.data?.routes) 
              ? payload.data.routes 
              : [];
      const count = typeof payload?.data?.count === 'number' 
        ? payload.data.count 
        : Array.isArray(routesArray) 
          ? routesArray.length 
          : 0;
      return { data: routesArray, count };
    } catch (error) {
      throw error;
    }
  },
  getAssignedVehiclesByFilters: async (filters = {}) => {
    try {
      const params = { };
      if (filters.source) params.source = filters.source;
      if (filters.destination) params.destination = filters.destination;
      if (filters.timing) params.timing = filters.timing;
      const response = await axiosInstance.get('/Corrohealth/admin/routes/vehicles', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getRouteById: async (id) => {
    try {
      const response = await axiosInstance.get(`/Corrohealth/admin/routes/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  updateRoute: async (id, data) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/admin/routes/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  updateRouteStatus: async (id, status) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/admin/routes/${id}/status`, status);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  deleteRoute: async (id) => {
    try {
      const response = await axiosInstance.delete(`/Corrohealth/admin/routes/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};



export const gatemanApi = {
  add: async (data) => {
    try {
      const response = await axiosInstance.post('/Corrohealth/gatemen/add', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getApprovalSummaries: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/public/gatemen/approvals');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateApprovalStatus: async (email, appovedByAdmin) => {
    try {
      const response = await axiosInstance.post('/Corrohealth/public/gatemen/approval-status', {
        email,
        appovedByAdmin
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getAll: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/gatemen/getAll');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async (id, status) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/gatemen/${id}/status`, { status });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await axiosInstance.get(`/Corrohealth/gatemen/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/gatemen/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/Corrohealth/gatemen/delete/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getRoutesByVehicle: async (vehicleId) => {
    try {
      const response = await axiosInstance.get(`/Corrohealth/gatemen/routes/by-vehicle/${vehicleId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export const dashboardApi = {
  // Blind Integration API calls - these endpoints will be implemented in backend
  getBookingsPerRoute: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/dashboard/bookings-per-route');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getSeatUtilization: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/dashboard/seat-utilization');
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export const conferenceRoomApi = {
  add: async (data) => {
    try {
      const response = await axiosInstance.post('/Corrohealth/conference-rooms/add', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getAll: async (includeBookings = false) => {
    try {
      const params = includeBookings ? { includeBookings: true } : {};
      const response = await axiosInstance.get('/Corrohealth/conference-rooms/getAll', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getAllWithBookings: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/conference-rooms/getAll', {
        params: { includeBookings: true }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await axiosInstance.get(`/Corrohealth/conference-rooms/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/conference-rooms/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async (id, status) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/conference-rooms/${id}/status`, { status });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/Corrohealth/conference-rooms/delete/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Booking APIs
  createBooking: async (bookingData) => {
    try {
      const response = await axiosInstance.post('/Corrohealth/api/bookings', bookingData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createRecurringBooking: async (recurringData) => {
    try {
      const response = await axiosInstance.post('/Corrohealth/api/bookings/recurring', recurringData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getMyBookings: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/api/bookings/my');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getAllBookingRequests: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/api/bookings/all');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  cancelBooking: async (bookingId) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/api/bookings/${bookingId}/cancel`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  approveBooking: async (bookingId) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/api/bookings/${bookingId}/approve`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  rejectBooking: async (bookingId, reason) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/api/bookings/${bookingId}/reject`, { reason });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getAvailableSlots: async (roomId, date) => {
    try {
      const response = await axiosInstance.get(`/Corrohealth/conference-rooms/${roomId}/available-slots`, {
        params: { date }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  bulkDeleteBookings: async (bookingIds) => {
    try {
      const response = await axiosInstance.delete('/Corrohealth/api/bookings/bulk-delete', {
        data: { bookingIds }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Feedback APIs
  addBookingFeedback: async (bookingId, feedbackData) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/api/bookings/${bookingId}/feedback`, feedbackData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getBookingsNeedingFeedback: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/api/bookings/needs-feedback');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Statistics APIs
  getBookingStats: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/api/bookings/stats');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getPendingBookingsStatus: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/api/bookings/pending-status');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Export API
  exportBookings: async ({ startDate, endDate, status, location } = {}) => {
    try {
      const params = {};
      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;
      if (status) params.status = status;
      if (location) params.location = location;

      const response = await axiosInstance.get('/Corrohealth/api/bookings/export', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export const adminManagementApi = {
  // Get all admin users (SUPER_ADMIN only)
  getAllAdmins: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/admin/admins');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Update admin assigned locations (SUPER_ADMIN only)
  updateAdminLocations: async (userId, assignedLocations) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/admin/updateLocations/${userId}`, {
        assignedLocations
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get all unique locations
  getAllLocations: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/admin/locations');
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export const locationApi = {
  getAllLocations: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/locations');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getAllActiveLocations: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/locations/active');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getAllActiveLocationNames: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/locations/active/names');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getLocationById: async (id) => {
    try {
      const response = await axiosInstance.get(`/Corrohealth/locations/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createLocation: async (locationData) => {
    try {
      const response = await axiosInstance.post('/Corrohealth/locations', locationData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateLocation: async (id, locationData) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/locations/${id}`, locationData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  changeLocationStatus: async (id, status) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/locations/${id}/status`, null, {
        params: { status }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  deleteLocation: async (id) => {
    try {
      const response = await axiosInstance.delete(`/Corrohealth/locations/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getLocationsByRegion: async (region) => {
    try {
      const response = await axiosInstance.get(`/Corrohealth/locations/region/${region}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export const amenityApi = {
  getAll: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/api/amenities');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getActive: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/api/amenities/active');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await axiosInstance.get(`/Corrohealth/api/amenities/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  add: async (data) => {
    try {
      const response = await axiosInstance.post('/Corrohealth/api/amenities', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/api/amenities/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async (id, status) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/api/amenities/${id}/status?status=${status}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/Corrohealth/api/amenities/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  permanentDelete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/Corrohealth/api/amenities/${id}/permanent`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

// Password Management API
export const passwordApi = {
  changePassword: async (oldPassword, newPassword) => {
    try {
      const response = await axiosInstance.post('/Corrohealth/api/password/change', {
        oldPassword,
        newPassword
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  forgotPassword: async (email) => {
    try {
      const response = await axiosInstance.post('/Corrohealth/api/password/forgot', { email });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  resetPassword: async (token, newPassword) => {
    try {
      const response = await axiosInstance.post('/Corrohealth/api/password/reset', {
        token,
        newPassword
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

// Department Management API
export const departmentApi = {
  getAll: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/departments');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getActive: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/departments/active');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getActiveCodes: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/departments/active/codes');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getActiveNames: async () => {
    try {
      const response = await axiosInstance.get('/Corrohealth/departments/active/names');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await axiosInstance.get(`/Corrohealth/departments/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await axiosInstance.post('/Corrohealth/departments', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/departments/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async (id, status) => {
    try {
      const response = await axiosInstance.put(`/Corrohealth/departments/${id}/status?status=${status}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await axiosInstance.delete(`/Corrohealth/departments/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  initialize: async () => {
    try {
      const response = await axiosInstance.post('/Corrohealth/departments/initialize');
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

// Export all APIs as a single object for convenience
export default {
  userApi,
  vehicleApi,
  routesApi,
  gatemanApi,
  dashboardApi,
  conferenceRoomApi,
  amenityApi,
  passwordApi,
  departmentApi
};
